module.exports = __webpack_public_path__ + "static/media/coollogo_com-209701667.d6717fe3.svg";